<template>
	<div>
	   <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
            <v-flex xs12>
                <v-snackbar
                    v-model="alert" 
                    color="green lighten-2" 
                    class="white--text" 
                    top outlined dense 
                    type="success" text>
                    {{ message }}
                    <v-btn color="white"  text  @click="alert = false">  <v-icon color="maroon">mdi-close</v-icon></v-btn>
                </v-snackbar>
                 <v-snackbar
                    v-model="alert_error" 
                    color="red lighten-2" 
                    class="white--text" 
                    top outlined dense
                    type="error" text>
                    {{ error }}
                    <v-btn color="white"  text  @click="alert_error = false"> Close</v-btn>
                </v-snackbar>
           </v-flex>
            <v-flex xs11>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2 header">
                            <v-flex xs6 sm7>
                                <p class="text-color">Edit Registration</p>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex sm12 md12>
			    <v-form
                id="update_registration"
                @submit.prevent="validateBeforeSubmit('updateRegistration')"
                data-vv-scope="updateRegistration"
                ref="registration_form"
                v-model="valid">
	                <v-card-text>
	                  <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
						  <v-layout row wrap>
	                  	  <v-flex xs12 sm6 md5>
	                  	    <v-text-field
	                        name=" type"
	                        label="Type"
	                        id="type"
							:disabled= true
	                        v-model="toUpperCase"
                            :error-messages="errors.collect('updateRegistration.type')"
	                    	></v-text-field>
	                  	  </v-flex>             	  
	                  	</v-layout>
						  <v-layout row wrap>
	                  	  <v-flex xs12 sm6 md5>
	                  	    <v-text-field
	                        name=" Name"
	                        label="Name"
	                        id="name"
							:disabled= true
	                        v-model="user_detail.name"
                            :error-messages="errors.collect('updateRegistration.Name')"
	                    	></v-text-field>
	                  	  </v-flex>	     
						  <v-flex xs12 sm6 md5 offset-md-1>
	                  	    <v-text-field
	                        name="Mobile"
	                        label="Mobile"
	                        id="mobile"
	                        v-model="user_detail.mobile"
	                        maxlength="10"
							:disabled= true
                            :error-messages="errors.collect('updateRegistration.Mobile')"
	                    	></v-text-field>
	                  	  </v-flex>             	  
	                  	</v-layout>
						  <v-layout row wrap>
	                  	  <v-flex xs12 sm6 md5>
	                  	    <v-text-field
	                        name="Email"
	                        label="Email"
	                        id="Email"
							:disabled= true
	                        v-model="user_detail.email"
                            :error-messages="errors.collect('updateRegistration.Email')"
	                    	></v-text-field>
	                  	  </v-flex>
							<v-flex xs12 sm6 md5 offset-md-1>
		                  	    <v-text-field
		                        name="Purpose"
		                        label="Purpose"
		                        id="Purpose"
								v-validate="'required'"
		                        v-model="registration_object.purpose"
								:error-messages="errors.collect('updateRegistration.Purpose')"
		                    	></v-text-field>
	                  	  	</v-flex>
	                  	</v-layout>
	                  	<v-layout row wrap>
	                  	    <v-flex xs12 sm6 md5>
	                  	    	<v-menu
                            	v-model="from_menu"
                            	:close-on-content-click="false"
                            	transition="scale-transition"
                            	:nudge-right="40"
                            	offset-y
                                max-width="290px"
                            	min-width="290px"
                            	>
                            	<template v-slot:activator="{ on }">
                            	  <v-text-field
                            	    label="From Date"
                            	
                            	    readonly
                            	    v-on="on"
                            	    name="From Date"
                            	    v-model="registration_object.from_date"
                            	    v-validate="'required'"
                            		:error-messages="errors.collect('updateRegistration.From Date')"
                            	  ></v-text-field>
                            	</template>
                            	<v-date-picker v-if="from_menu" :min="nowDate" v-model="registration_object.from_date" @input="from_menu = false" >
                            	  
                            	</v-date-picker>
                            	</v-menu>
	                  	    </v-flex>
	                  	    <v-flex xs12 sm6 md5 offset-md-1 v-if="registration_object.type=='vendor'">
	                  	        <v-menu
	                  	        ref="to_menu"
                                v-model="to_menu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                                >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    label="To Date"
                                   
                                    readonly
                                    v-on="on"
                                    name="To Date"
                                    v-model="registration_object.to_date"
                                    v-validate="'required'"
                            		:error-messages="errors.collect('updateRegistration.To Date')"
                                  ></v-text-field>
                                </template>
                                <v-date-picker v-if="to_menu" :min="registration_object.from_date" v-model="registration_object.to_date" @input="to_menu = false" >
                                  
                                </v-date-picker>
                                </v-menu>
	                  	    </v-flex>
	                  	</v-layout>
	                            	<!-- ------------------------------- -->
					<v-layout row wrap v-if="registration_object.type!='vendor'">
	                  	    <v-flex xs12 sm6 md5>
	                  	    	<v-menu
                            	v-model="from_time_menu"
                            	:close-on-content-click="false"
                            	transition="scale-transition"
                            	:nudge-right="40"
                            	offset-y
                            	>
                            	<template v-slot:activator="{ on }">
                            	  <v-text-field
                            	    label="From Time"
                            	    readonly
                            	    v-on="on"
                            	    name="From Time"
                            	    v-model="registration_object.start_time"
                            	    v-validate="'required'"
                                    :error-messages="errors.collect('createRegistration.From Time')"
                            	  ></v-text-field>
                            	</template>
                            	<v-time-picker v-if="from_time_menu"  
								 v-model="registration_object.start_time" @input="from_time_menu = false"
                            	ampm-in-title>
                            	</v-time-picker>
                            	</v-menu>
	                  	    </v-flex>
							  <v-flex xs12 sm6 md5 offset-md-1>
	                  	    	<v-menu
                            	v-model="to_time_menu"
                            	:close-on-content-click="false"
                            	transition="scale-transition"
                            	:nudge-right="40"
                            	offset-y
                                max-width="290px"
                            	min-width="290px"
                            	>
                            	<template v-slot:activator="{ on }">
                            	  <v-text-field
                            	    label="To Time"
                            	    readonly
                            	    v-on="on"
                            	    name="To Time"
                            	    v-model="registration_object.end_time"
                            	    v-validate="'required'"
                                    :error-messages="errors.collect('createRegistration.To Time')"
                            	  ></v-text-field>
                            	</template>
                            	<v-time-picker v-if="to_time_menu"  :min="registration_object.start_time" v-model="registration_object.end_time" @input="to_time_menu = false" ampm-in-title
                            	>
                            	</v-time-picker>
                            	</v-menu>
	                  	    </v-flex>
	                    	</v-layout>
							<!-- ------------------------------- -->        	
	                  </v-container>
	                </v-card-text>
	                <v-card-actions>
	              	<v-spacer></v-spacer>
	              		<v-btn color="primary" small :disabled="!valid" :loading="loaders.submit_loader" type="submit">Update</v-btn>
	              		<v-btn text small to="/registrations">Cancel</v-btn>
	          		</v-card-actions>
          		</v-form>
			    </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
	</div>
</template>
<script>
  export default {
  	computed:{
  		toUpperCase(){
  			return this.registration_object.type.toUpperCase();
  		}
  	},
  	watch:{
      "registration_object.start_time": {
            handler(val) {
                if (val) {
					this.registration_object.end_time = moment(val,'HH:mm').add(1, 'hour')
					.format('HH:mm');
					
                } 

            }
        },
        "registration_object.from_date": {
            handler(val) {
                if (val) {
                    if(this.count>0){
                         this.registration_object.to_date = moment(val,'YYYY-MM-DD').add(0, 'day').format('YYYY-MM-DD')
					}
					this.count= this.count+1;
                } 

            }
        },

  	},
  	methods:{
		
			validateBeforeSubmit: function(scope) {  
		      this.$validator.validateAll(scope).then(result => {
				if (result) {
		          this[scope]();
		        }
		     });
			},
			updateToTime:function(start_time)
            {
                
                this.registration_object.end_time = moment(start_time,'HH:mm').add(1, 'hour').format('HH:mm');
            },
    		updateRegistration:function(){
    			this.loaders.submit_loader =true;
    	    	axios.post(`${process.env.VUE_APP_API_URL}/api/registrations/`+this.$route.params.id + `/update`, this.registration_object).then((response)=>{
    			if(response.data.status == 1)
				{	  
			      this.$router.push({ name: 'showRegistrationDetails',
                        params: {
                            id: this.$route.params.id,
                        }});
			      this.loaders.submit_loader =false;    
                }
                 if (response.data.status == 0) {
                    this.alert_error=true;
                    this.error = response.data.message;
                    this.loaders.submit_loader = false;
                }
				}).catch((error)=>{
				  console.log(error);
				}).finally(()=>{

				});	
			},
			
    		getRegistrationDetails: function() {
    			this.loaders.detail_loader=true;
		      axios
		        .get(
		          `${process.env.VUE_APP_API_URL}/api/registrations/`+this.$route.params.id + `/edit`
		        )  
		        .then(response => {	    
						
		          if (response.data.status == 1) {
					this.registration_object = response.data.registration;
					this.user_detail = response.data.registration.record;
                    
					var st = this.registration_object.from_date;
					this.registration_object.start_time = st.split(" ")[1];
				   
				    var et = this.registration_object.to_date;
					this.registration_object.end_time = et.split(" ")[1];

					this.registration_object.from_date = moment(this.registration_object.from_date).format('YYYY-MM-DD');
					this.registration_object.to_date = moment(this.registration_object.to_date).format('YYYY-MM-DD');
					this.loaders.detail_loader=false;

		          }
		        })
		        .catch(error => {
		         console.log(error);
		        })
		        .finally(() => {});
			},
    },
    data:()=>{
        return{
			error:'',
			registration_object:{
			name:'',
        	mobile:'',
        	email:'',
        	type:'',
        	from_date:'',
			to_date:'',
			start_time:'',
	    	end_time:'',
			},
			 nowDate: new Date().toISOString().slice(0,10),
			loaders:{
				detail_loader:false,
				submit_loader:false,
			},
			role:'',
			loading:false,
			loader:null,
		    user_detail:'',
        	from_menu:false,
        	to_menu:false,
			valid:false,
			count:'0',
     
		from_date_menu:false,
        to_date_menu:false,
        from_menu:false,
		to_menu:false,
		
		from_time_menu:false,
        to_time_menu:false,
        from_time_menu:false,
        to_time_menu:false,
        
        message:'',
        alert:'',
        alert_error:'',

		}
    },
    mounted(){
	    this.role = localStorage.getItem('visitor_management_role');
		this.getRegistrationDetails();
	},
  };
</script>
<style scoped>
.theme--light.v-card {
    background-color: #FFFFFF;
    color: rgba(0, 0, 0, 0.87);
	padding:5%;
}
</style>